import { render, staticRenderFns } from "./BikyConfigChat.vue?vue&type=template&id=15959bd8&scoped=true&"
import script from "./BikyConfigChat.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigChat.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigChat.vue?vue&type=style&index=0&id=15959bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15959bd8",
  null
  
)

export default component.exports